module.exports = __webpack_public_path__ + "img/peter_d.810547b0.png";